import { useSelector } from "react-redux";
import moment from "moment";
import ProfilePicDecorator from "../../assets/developer-details/ProfilePicDecorator.svg";
import DummyProfilePic from "../../assets/common/DummyProfile.jpg";
import Image from "../../components/general/Image";
import PriceTag from "../../assets/common/PriceTag.svg";
import Button from "../../components/general/Button";
import DashedChips from "../../components/common/DashedChips";
import Verified from "../../assets/developer-details/Verified.svg";
import { ROUTES } from "../../routes/RouteList";
import useDocumentTitle from "../../hooks/useDocumentTitle";

const DeveloperProfile = ({ onUnlockRatesClick }) => {
    const { developer: { detail } } = useSelector(state => state.common);
    useDocumentTitle(detail?.first_name || "Developer Profile");

    return (
        <div className="bg-[#292929] text-white pb-[100px]">
            {
                detail?.display_pay_range ? (
                <div className="relative">
                    <Image className="absolute top-[20px] w-[95px] h-[50px] right-0" src={PriceTag} alt="price-tag" />

                    <div className="relative z-1 top-[20px] pr-[10px] flex flex-col justify-end items-end">
                        <span className="font-bold text-[18px] text-black"> ${detail.display_pay_range} </span> 
                        <span className="block">Per Hour</span>
                    </div>
                </div>
                )
                :
                <div className="pb-[50px]" />
            }

            <div className="px-[20px] lg:px-[40px] -mt-[20px]">
                <div className="profileImg">
                    <div>
                        <span className="logo-block"><Image className="translate-x-[-10px] w-[20px]" src={ProfilePicDecorator} alt="logo-block" /></span>
                        <figure><Image className="w-[100px] h-[100px] rounded-[6px]" src={detail.profile_picture?.file || DummyProfilePic} alt="profile-pic" /></figure>
                    </div>
                </div>
                <div className="text-[22px] lg:text-[30px] font-semibold flex items-center gap-[10px] justify-start mt-[10px]">
                    <span>{detail.first_name}</span>
                    {
                        detail.country && detail.country.flag && (
                            <Image className="w-[30px] h-[20px]" src={detail.country.flag.file} alt="" />
                        )
                    }
                </div>
                {
                    detail.country && detail.country.name && (
                        <p className="text-[#A0A0A0] font-extralight text-[12px] lg:text-[0.8rem]">From {detail.country?.name}</p>
                    )
                }
                <p className="text-[16px] lg:text-[20px] font-semibold mt-[5px]">{detail?.specialization?.name}</p>

                {
                    detail.display_pay_range ?
                    <Button className="bg-primary-color rounded-[6px] text-black h-[40px] mt-[40px] md:w-[200px] px-[10px]" onClick={onUnlockRatesClick}>Hire {detail?.first_name} now <i className="fa-solid fa-arrow-up-right" /></Button>
                    :
                    <Button className="bg-primary-color rounded-[6px] text-black h-[40px] mt-[40px] px-[10px] md:w-[250px]" onClick={onUnlockRatesClick}> Unlock Rates & Hire Now <i className="fa-solid fa-arrow-up-right" /></Button>
                }

                <div className="text-[16px] font-semibold mt-[10px]">{detail.total_experience} years of commercial experience</div>
                
                <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-3 gap-[10px] mt-[20px]">
                    {
                        detail?.tags && detail?.tags.length > 0 && detail?.tags.map((tag, index) => (
                            <DashedChips keyName={index} text={`#${tag}`} />
                        ))
                    }
                </div>

                <DevStats {...{ detail }} />

                <div className="flex items-center gap-[10px] mt-[20px] bg-[#0090FF] rounded h-[40px] px-[10px] md:w-[300px] lg:w-[60%] lg:mb-[40px]">
                    <Image src={Verified} alt="verified" className="w-[20px] h-[20px]" />
                    <p className="text-white text-[12px] text-center">Skills and seniority verified on {moment(detail?.date_approved).format("MMM DD, YYYY")}</p>
                </div>
            </div>
        </div>
    );
};

const DevStats = ({ detail }) => {
    return (
        <div className="">
            <h3 className="font-semibold text-primary-color mt-[20px] text-[18px] lg:text-[20px]">DevHire Stats</h3>

            <div className="grid grid-cols-2 md:flex md:justify-start md:items-center gap-[10px] mt-[20px]">
                <div className="flex items-center gap-[10px] justify-center flex-col rounded-[10px] bg-black p-[10px] w-[130px] h-[130px]">
                    <p className="text-[30px] font-semibold">{detail?.no_of_projects || 0}</p>
                    <p className="text-[12px] text-[#888888] font-extralight">projects done</p>
                </div>

                <div className="flex items-center gap-[10px] justify-center flex-col rounded-[10px] bg-black p-[10px] w-[130px] h-[130px]">
                    <p className="text-[30px] font-semibold">{detail?.hours_worked || 0}</p>
                    <p className="text-[12px] text-[#888888] font-extralight">hours worked</p>
                </div>

                <div className="flex items-center gap-[10px] justify-center flex-col rounded-[10px] bg-black p-[10px] w-[130px] h-[130px]">
                    <p className="text-[25px] font-semibold">{detail?.open_to_new_offers ? "Open" : "Closed"}</p>
                    <p className="text-[12px] text-[#888888] font-extralight text-center">to new offers</p>
                </div>
            </div>
        </div>
    );
};

export default DeveloperProfile;